export default "<app-terminal-view></app-terminal-view>\r\n<app-shopping-list></app-shopping-list>\r\n";